export default "__VITE_ASSET__jvFF2cs6__"